<template>
    <div id="vy_main" style="overflow-x:hidden">
      <main>
              
          <div id="overlay" v-if="message_flag == false">
              <img  src="../../images/loading.gif" alt="ローディング中" />
          </div>
      </main>
    </div>
    
        
    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                v-on:ok_message="OK_message"/>
</template>
  
    
<script setup>
  /* eslint-disable */
  import MessageModal from '../common/MessageModal.vue'  
  import { useRouter } from 'vue-router'
  import { login_check,logout } from '../js/userdata.js';

import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies()

import axios from 'axios'
  const router = useRouter();
  /* 表示する子コンポーネント関係の情報 */
  
let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント
  import { shallowRef, watch, ref } from 'vue'
  const content = shallowRef('')

  let param = {}
  let title = "ボラ活エール"

  let show_ok = ref(0)

      
    // URLにエラーメッセージがあるかチェック
    let redirect_error_check = function(){
        
        setTimeout(function(){
            // LINEログインでエラーが発生した場合はURLに「?error=」「&error_description」がついてるのでチェック
            const params = new URLSearchParams(location.search)
            const error = params.get("error")

            // エラーが存在するか
            if (error) {
              let return_city = localStorage.getItem('return_shakyo')
              logout(return_city)//ログアウト
              const errorDesc = params.get("error_description")
              // Eメール未指定によるエラーであるかキーワードをチェック
              if (errorDesc?.includes("email")) {
                message.value = "LINEにメールアドレスが設定されていなかったため、アカウント作成またはログインができませんでした。\nメールアドレスを設定してから、再度新規登録を行ってください。\n\n※設定の仕方が分からない場合は、<a href='https://guide.line.me/ja/account-and-settings/account-and-profile/set-email-address.html' target='_blank'>こちら</a>をご覧ください。";
              }else{
                message.value = "予期せぬエラーが発生し、アカウント作成またはログインができませんでした。\n恐れ入りますがもう一度お試しください。";
              }
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "line_login_error";
              contentMessage.value = MessageModal
            }else{
              setTimeout(function(){
                handleCallback()
              },"100")
            }
        },"1500")
    }

   let redirectUri = location.protocol+"//"+location.host+"/redirect"
   let handleCallback_error = 0
   async function handleCallback(){

      let return_city = localStorage.getItem('return_shakyo')
          let return_url = location.protocol+"//"+location.host+"/"+return_city+"/Taiken"
          let redirectUri = location.protocol+"//"+location.host+"/redirect"
          // チェックイン画面から来た場合はチェックイン画面に戻れるようにする
          if(localStorage.getItem('checkin') != null && localStorage.getItem('checkin') != undefined){
                return_url = return_url + "/" + localStorage.getItem('checkin') + "/" + localStorage.getItem('checkin_id')
          }
            
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const provider = params.get("state");
        
        if (code) {
          try {
            // 認可コードをサーバーに送る
            await axios.post("dev/social_lambda", { code,redirectUri }, { withCredentials: true });
            cookies.set('provider', provider, '7d'); 
            location.href = return_url
          } catch (err) {
              console.error("ログイン処理失敗", err);
              let return_city = localStorage.getItem('return_shakyo')
              logout(return_city)//ログアウト
              message.value = "ログインに失敗しました。\n恐れ入りますがもう一度お試しください。";
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "line_login_error";
              contentMessage.value = MessageModal
              handleCallback_error++
                
          }
      }
    }

        
    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 

        message_flag.value = false;
        contentMessage.value = null
        
        let return_city = localStorage.getItem('return_shakyo')

        setTimeout(function(){
          location.href = location.protocol+"//"+location.host+"/"+return_city+"/Taiken"
        },"1500")
        localStorage.removeItem('return_shakyo') 
    }

    
  // 初期処理
  redirect_error_check()
 </script>
  
<style scoped>

  #main_area{
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #main_area_link{
    font-size: 17px;
    display: flex;
    justify-content: space-evenly;
    width: 50%;
    height: 200px;
    align-items: center;
  }
  #main_area_link a,
  #main_area_link a:hover{
    color:black;
    text-decoration-line:underline
  }

</style>
  